const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const NumberUtil = require("../../../shared/Numbers");
const OdometerDigit = require("./OdometerDigit");

const styles = require("./styles/BucksOdometer.css");

module.exports = createReactClass({
	displayName: "BucksOdometer",

	propTypes: {
		className: PT.string,
		bucks: PT.number.isRequired,
	},

	renderDigit: function(digit, pos) {
		return (
			<div className={styles.digitOuter} key={"p" + pos}>
				<OdometerDigit digit={digit} />
			</div>
		);
	},

	render: function() {
		const bucksToDisplay = NumberUtil.withCommas(this.props.bucks);
		const bucksEl = _.map(bucksToDisplay, (d, i) => {
			const pos = bucksToDisplay.length - i;
			if (_.isInteger(parseInt(d))) return this.renderDigit(parseInt(d), pos);
			else
				return (
					<div className={styles.nonDigit} key={"comma" + pos}>
						{d}
					</div>
				);
		});
		let mainClass = styles.main;
		if (this.props.className) mainClass += " " + this.props.className;
		return (
			<div className={mainClass}>
				<div className={styles.bao}>B</div>
				{bucksEl}
			</div>
		);
	},
});
